/* eslint-disable max-len */
import { useState, useEffect, useContext } from "react";
import { useScreenClass } from "react-grid-system";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { NullStateText } from "../../components/Text";
import SnackBar from "../../components/SnackBar";
import axios from "axios";
import {
  EmptyPillarNavigation,
  EmptyPillarTypeDetail,
  PillarNavigationType,
  PillarTypeDetail,
} from "../../types/Roadmap";
import PillarOverviewModify from "../../components/PillarOverviewModify";
import PillarNavigator from "../../components/PillarNavigator";
import LoadingSpinner from "../../components/LoadingSpinner";
import { VersionContext } from "../../context/VersionContext";

export const CustomFlex = styled(FlexBox)`
  padding: 40px 16px;
  align-items: center;
  border-bottom: 1px solid #94a3b8;
  background: white;
`;
interface CourseColumn {
  id: "title" | "number" | "pillar" | "competencies";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}

function ModifyPillarDetail(this: any) {
  const { pillarId } = useParams();
  const screenClass = useScreenClass();
  const [pillarDetail, setPillarDetail] = useState<PillarTypeDetail>(
    EmptyPillarTypeDetail
  );
  const [pillarNavigation, setPillarNavigation] =
    useState<PillarNavigationType>(EmptyPillarNavigation);
  const [loading, setLoading] = useState<boolean>(false);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const { version } = useContext(VersionContext);

  useEffect(() => {
    if (pillarId) fetchPillar(pillarId);
  }, []);
  const fetchPillar = (pillar_id: string) => {
    setLoading(true);
    axios
      .get(`/pillar?curriculum_version=${version.version_number}`)
      .then((res) => {
        filterData(res.data.pillars, pillar_id);
      })
      .catch(() => {});
  };
  const filterData = (data: any, id: string) => {
    data.forEach((element: any, index: any) => {
      if (element.id === id) {
        setPillarDetail(element);
        setPillarNavigation({
          ...pillarNavigation,
          code: element.code,
          description: element.description,
          graphics: element.graphics,
          id: element.id,
          is_core: element.is_core,
          title: element.title,
        });
      }
      setLoading(false);
    });
  };
  const updatePillarData = (data: any) => {
    setLoading(true);
    console.log(data);
    axios
      .put("/pillar/update", data)
      .then((res) => {
        setMessage("Updated pillar successfully");
        setIsSnackbarOpen(true);
        fetchPillar(pillarDetail.id);
        setLoading(false);
      })
      .catch(function (error) {
        if (error.response) {
          setMessage(error.response.data.error || "Failed to update pillar!");
          setIsErrorOpen(true);
        } else if (error.request) {
          console.log(error.request);
        } else {
          setMessage(error.response.data.error);
          setIsErrorOpen(true);
        }
        setLoading(false);
      });
  };
  return (
    <>
      <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message}
        type="success"
      />
      <SnackBar
        isOpen={isErrorOpen}
        setOpen={setIsErrorOpen}
        header="Error!"
        message={message}
        type="error"
      />
      {pillarDetail && pillarDetail.id !== "" ? (
        <CustomFlex
          style={{
            minHeight: "inherit",
            height: "100%",
            borderBottom: "none",
            alignItems: "flex-start",
            overflowY: "scroll",
            padding: 0,
          }}
        >
          <FlexGrow
            className="visible-scrollbar"
            style={{
              overflowX: "auto",
              maxHeight: "calc(100vh - 90px)",
              minHeight: "calc(100vh - 90px)",
            }}
          >
            <CustomFlex>
              <FlexGrow>
                <PillarNavigator path={pillarNavigation} />
              </FlexGrow>
            </CustomFlex>
            {loading && <LoadingSpinner />}
            <PillarOverviewModify
              pillarData={pillarDetail}
              goBack={() => {}}
              onSaveComplete={(data) => {
                updatePillarData(data);
              }}
            />
          </FlexGrow>
        </CustomFlex>
      ) : (
        <LoadingSpinner />
      )}
    </>
  );
}
export default ModifyPillarDetail;
